import liveCuepoints from './LiveCuepoints/Archetype.js';

export default class LiveCuepointsManager {

    actions = {};
    bufferActions = [];
    notEmit = false;
    cuepointsType = {};
    
    constructor(sdk) {
        this.sdk = sdk;
        this.cuepointsType['chapter'] = new liveCuepoints('chapter', sdk);
        this.cuepointsType['speaker'] = new liveCuepoints('speaker', sdk);
        this.lastActions = {};
    }
    
    addAction(data) {
        if(!this.actions[data.id] && data.live_second != -1) {
            let res = this.processAction(data);
            if(res)
                this.actions[data.id] = data;
        }
        else {
            //console.log('action already exist or last_second -1', data.id, data.last_second)
        }
        
    }
    
    processAction(data) {
        if ((data.action == 'chapter' || data.action == 'speaker') && this.sdk.mediaPlayer && data.live_second > this.sdk.mediaPlayer.getRealDuration() && this.sdk.mediaPlayer.isLive() > -1) {
            this.bufferActions.push(data);
            return false;
        }
        else {
            if(this.cuepointsType[data.action]) {
                //console.warn(data.action, data)
                this.cuepointsType[data.action].addCue(data);    
            }
            /*if (data.action == 'chapter') {
                if(window.live)
                    console.log('add chapter', data.id, data.live_second, this.sdk.mediaPlayer.getRealDuration());
            
            }*/
            return true;
        }
    }
    
    async load() {
        let actions = await this.sdk.fetch('/stream/' + window.programId + '/dvr/actions');
        //console.log(actions)
        for (var i in actions) {
            this.notEmit = true;
            this.addAction(actions[i]);
        }
        this.notEmit = false;
        for(var i in this.cuepointsType) {
            this.cuepointsType[i].emitCurrentLive();
        }
    }

    
    
    processBuffer(currentTime) {
        for (var i in this.bufferActions) {
            let action = this.bufferActions[i]
            if (currentTime > action.live_second) {
                console.log('let go', currentTime, action.live_second)
                if(action.value && action.value.file) {
                    this.sdk.emit('media_change', {
                        url : action.value.file
                    })
                }
                this.addAction(action);
                this.bufferActions.splice(i, 1);
            }
        }
    }
    
    findLiveCurrents(time) {
        for(var i in this.cuepointsType) {
            this.cuepointsType[i].findLiveCurrent(time);
        }
    }

}



// WEBPACK FOOTER //
// ./src/Sdk/LiveCuepointsManager.js